export const INDUSTRY_TYPES = [
  "Generic Modernization",
  "Financial Services / Banking",
  "Technology / Software / IT Services",
  "Healthcare & Life Sciences",
  "Retail / E-Commerce",
  "Telecommunications & Network Services",
  "Manufacturing / Industrial",
  "Energy / Utilities",
  "Transportation & Logistics",
  "Insurance (P&C, Life, Health)",
  "Retail Banking / Insurance Tech",
  "Media / Entertainment / Content Platforms",
  "Government",
  "Education",
  "Life Sciences",
  "Higher Education",
  "Custom"
];

export default INDUSTRY_TYPES;